/**
 * @typedef {import('./plottr').Slate} Slate
 */

/**
 * @typedef FileURI
 * @property {String} uri
 */

/**
 * @typedef BaseIdeaFields
 * @property {number} id
 * @property {String} deviceId
 * @property {String} name
 * @property {UniversalThreadId} threadId
 * @property {String} isoTimestamp
 * @property {String} createdISOTimestamp
 * @property {number} nameModifiedTimestampMS
 * @property {Array<SlatePatch>} patches
 * @property {boolean} [deleted]
 */

/**
 * @typedef TextIdeaExt
 * @property {'text'} kind
 * @property {Slate} data
 */

/**
 * @typedef PhotoIdeaExt
 * @property {'photo'} kind
 * @property {Slate} description
 * @property {FileURI} data
 */

/**
 * @typedef AudioIdeaExt
 * @property {'audio'} kind
 * @property {Slate} description
 * @property {FileURI} data
 */

/**
 * @typedef {BaseIdeaFields & TextIdeaExt} TextIdea
 */

/**
 * @typedef {BaseIdeaFields & PhotoIdeaExt} PhotoIdea
 */

/**
 * @typedef {BaseIdeaFields & AudioIdeaExt} AudioIdea
 */

/**
 * @typedef {TextIdea | PhotoIdea | AudioIdea} Idea
 */

/**
 * @typedef {import('../version_control/index').SlatePatch} SlatePatch
 */

/**
 * @typedef UniversalIdeaId
 * @property {String} deviceId
 * @property {number} ideaId
 */

/**
 * @typedef UniversalThreadId
 * @property {String} deviceId
 * @property {number} threadId
 */

/**
 * @typedef Thread
 * @property {number} id
 * @property {String} name
 * @property {String} imageURI
 * @property {Slate} description
 * @property {Array<SlatePatch>} patches
 * @property {Array<UniversalIdeaId>} ideas
 * @property {String} deviceId
 * @property {String} isoTimestamp
 * @property {number} nameModifiedTimestampMS
 * @property {number} imageModifiedTimestampMS
 * @property {boolean} [deleted]
 */

/**
 * Produce a string identifier that should uniquely identify the
 * thread or idea produced by a device with a supplied id and given
 * its own id.
 *
 * @param {String} deviceId
 * @param {number} numberId
 * @return {String}
 */
export const toUniqueId = (deviceId, numberId) => {
  return `"${deviceId.replace(/"/g, '\\"')}"${numberId}`
}

/**
 * Produce a UniversalIdeaId from the given deviceId and ideaId.
 *
 * @param {String} deviceId
 * @param {number} ideaId
 * @return {UniversalIdeaId}
 */
export const toUniversalIdeaId = (deviceId, ideaId) => {
  return {
    deviceId,
    ideaId,
  }
}
